import React, { useState } from 'react'
import styled from 'styled-components'
import { Link, Flex, Button, Image, Text } from '@crystals/uikit'
import { scroller } from 'react-scroll'
import { Dispatch} from "redux"
import {useDispatch, useSelector,shallowEqual} from "react-redux"
import Web3 from 'web3';
import { NavLink } from 'react-router-dom'
import { addArticle } from "../../../../store/actionCreators"
import { PushedProps } from '../types'
import ConnectWallet from './ConnectWallet'

interface Props extends PushedProps {
  isMobile: boolean
  togglePush: () => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  alignItems: center;
  vertical-align: center;
`

const LinkText = styled(Text)`
  font-family: Poppins, sans-serif;
  font-size: 36px;
  line-height: 1;
  cusor: pointer;
  font-weight: 700;
  text-align: center;
`

const Panel = styled.div`
  padding: 30vh 70px;
`

const PanelButton = styled(Button)`
  background: #b07efa;
  text-align: center;
  box-shadow: 1px 1px 5px 1px rgb(14 14 44 / 19%);
  width: 170px;
  height: 50px;
  padding: 15px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: #00e0b8;
  font-family: Biennale, sans-serif;
  color: #07071c;
  font-size: 17px;
  line-height: 1;
  font-weight: 500;
  &:hover {
    opacity: 0.7;
  }
`

const web3 = new Web3(window.ethereum);

const PanelBody: React.FC<Props> = ({ pushNav, isMobile, togglePush }) => {
  // Close the menu when a user clicks a link on mobile
  const handleClick = isMobile ? () => pushNav(false) : undefined
  const innerLogo = <Image src="/images/landing/logoTitle.svg" alt="choose" width={140} height={140} />
  const articles: IArticle = useSelector(
    (state: ArticleState) => state.articles,
    shallowEqual
  )

  const goRecent = () =>
    scroller.scrollTo('RecentPlayed', {
      duration: 2000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 50,
    })
  
  const goHTP = () =>
    scroller.scrollTo('HowToPlay', {
      duration: 2000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 50,
    })

  const chainId = 80001; // main net
  
  const [article, setCurrentAddr] = useState("");

  const connectWallet = async () => {
    if (window.ethereum) {
      // const web3 = new Web3(window.ethereum)
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" })
        const accounts = await window.ethereum.request({ method: 'eth_accounts' })
        addNewArticle(accounts[0]);
        setCurrentAddr(accounts[0]);
        window.ethereum.on('chainChanged', () => {
            window.location.reload();
        });

        await runAPP();

        return
      } 
      catch (error) {
        console.error(error)
      }
    }
  }

  const dispatch: Dispatch<any> = useDispatch()

  const addNewArticle = React.useCallback(
    (article1: IArticle) => dispatch(addArticle(article1)),
    [dispatch]
  )

  const runAPP = async () => {
    const currNetworkID = await web3.eth.net.getId()
    if (currNetworkID === chainId) {
      // tokenContract = await new web3.eth.Contract(TOKEN_ABI, TOKEN_ADDRESS);
    }
  }

  return (
    <Container>
      <Panel>        
        <Flex justifyContent="left" alignItems="center" mt="40px">
          <NavLink to="/">
            <LinkText
              onClick={() => {
                handleClick()
                goHTP()
              }}
            >
                How it works
            </LinkText>
          </NavLink>
        </Flex>
        <Flex justifyContent="left" alignItems="center" mt="40px" mb="40px">
          <NavLink to="/">
            <LinkText onClick={() => {
                handleClick()
                goRecent()
              }}>
              Recent
            </LinkText>
          </NavLink>
        </Flex>
        <ConnectWallet />
      </Panel>
    </Container>
  )
}

export default PanelBody
